import { render, staticRenderFns } from "./ProfissionaisPecCnes.vue?vue&type=template&id=3410c53a"
import script from "./ProfissionaisPecCnes.vue?vue&type=script&lang=js"
export * from "./ProfissionaisPecCnes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports